import { createFileRoute, Outlet } from "@tanstack/react-router";
import { getSubmission } from "api-client";

import { loaderHandler } from "src/lib/loaderHandler";
import { QuestionnaireSubmissionContextProvider } from "src/questionnaire/QuestionnaireSubmissionContext";

export const Route = createFileRoute(
  "/_auth/_athlete/questionnaire-submissions/$submissionId",
)({
  component: RouteComponent,
  ssr: true,
  shouldReload: false,
  async loader({ params }) {
    return await loaderHandler(async () => {
      const questionnaireSubmission = await getSubmission({
        path: {
          submissionId: params.submissionId,
        },
      }).then((response) => {
        return response.data.data;
      });

      return {
        data: {
          questionnaireSubmission,
          key: Math.random(),
        },
        breadcrumb: {
          href: `/questionnaire-submissions/${params.submissionId}`,
          label: questionnaireSubmission.questionnaire.name,
        },
      };
    });
  },
});

function RouteComponent() {
  const { data } = Route.useLoaderData();

  return (
    <QuestionnaireSubmissionContextProvider
      key={data.key}
      questionnaireSubmission={data.questionnaireSubmission}
    >
      <Outlet />
    </QuestionnaireSubmissionContextProvider>
  );
}
